import type { Download } from "@/types/util"
import { useDownloadListQuery } from "@/hooks/api/useUtilQuery"
import { Paper, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import BasicButton from "@/components/button/BasicButton"

import "./DownloadList.scss"
import Icon from "@/components/icon/Icon"

export default function DownloadList() {
  const { data, isError } = useDownloadListQuery()
  const { t } = useTranslation("")

  function downloadURI(uri: string, name: string) {
    // 현재는 다운로드 파일이 데이터 매니저밖에 없어서 전체로 처리해둠
    window.alert(t("messages.confirmDownloadDataManager"))
    const link = document.createElement("a")
    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  if (isError) {
    return <Typography color="error">Failed to load downloads</Typography>
  }

  if (!data || !Array.isArray(data)) {
    return <Typography color="error">Invalid data format</Typography>
  }

  return (
    <div className="DownloadList">
      <h3 className="settings-section-title">{t("swDownload")}</h3>
      <div className="DownloadRowsCont">
        {data.map((download: Download) => (
          <div key={download.name} className="DownloadRowCont">
            <div className="Text">
              <span className="Title">
                {download.name} v{download.swVersion}
              </span>
              <span className="Description">{download.description}</span>
            </div>
            <BasicButton
              className="Button"
              icon="download"
              type="primary-outlined"
              size="md"
              onClick={() => downloadURI(download.url, download.name)}>
              {t("button.download")}
            </BasicButton>
          </div>
        ))}
      </div>
    </div>
  )
}
